import {
  merge, concat, reject, isNil, propEq, find, isEmpty, insert, findIndex
} from 'ramda';
import {
  LOAD_SUCCESS,
  LOAD_OPTIONS_SUCCESS,
  LOAD_REQUEST,
  LOAD_FAIL,
  DELETE_REQUEST,
  DELETE_FAIL,
  SUBMIT_FAIL,
  SUBMIT_SUCCESS,
  SUBMIT_REQUEST,
  UPDATE_FAIL,
  UPDATE_REQUEST,
  DELETE_SUCCESS,
  UPDATE_SUCCESS
} from 'src/store/actions/wccActions';

const initialState = {
  list: [],
  options: [],
  fetching: false,
  errors: []
};


const addOrReplaceInList = (wcc, prop, list) => {
  const current = (find(propEq(prop, wcc[prop]), list)); // find relevant wcc from list
  if (isEmpty(current) || isNil(current)) { // if the wcc does not exist ( was submit )
    return concat([wcc], list);
  }
  // if it exists, then add it to the list (on the same place it was before) and remove the old value.
  return insert(findIndex(propEq(prop, wcc[prop]), list), wcc, reject(propEq(prop, wcc[prop]), list));
};

const getNewWccOption = (wcc) => ({
  value: wcc.Id,
  label: wcc.WorkCenterCodeName
});


const workShiftsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case LOAD_SUCCESS:
      return merge(state, {
        list: action.wcc,
        fetching: false,
        errors: []
      });
    case LOAD_OPTIONS_SUCCESS:
      return merge(state, {
        options: action.options,
        fetching: false,
        errors: []
      });
    case SUBMIT_REQUEST:
      return merge(state, { fetching: true });
    case SUBMIT_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case SUBMIT_SUCCESS:
      return merge(state, {
        list: addOrReplaceInList(action.result, 'Id', state.list),
        options: addOrReplaceInList(getNewWccOption(action.result), 'value', state.options),
        fetching: false,
        errors: []
      });
    case UPDATE_REQUEST:
      return merge(state, { fetching: true });
    case UPDATE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case UPDATE_SUCCESS:
      return merge(state, {
        list: addOrReplaceInList(action.result, 'Id', state.list),
        options: addOrReplaceInList(getNewWccOption(action.result), 'value', state.options),
        fetching: false,
        errors: []
      });
    case DELETE_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('Id', action.wccId), state.list),
        options: reject(propEq('value', action.wccId), state.options)
      });
    default:
      return state;
  }
};

export default workShiftsReducer;
